import { jsx as a } from "react/jsx-runtime";
import { Badge as n } from "@chakra-ui/react";
const t = {
  neutral: "gray",
  error: "red",
  success: "green",
  warning: "orange",
  info: "blue",
  recommendation: "teal"
}, m = ({ children: e, status: r = "neutral", ...o }) => /* @__PURE__ */ a(n, { colorScheme: t[`${r}`], ...o, children: e });
export {
  m as Badge
};
